import React from 'react'
import { Button, IconButton, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material'
import MicNoneIcon from '@mui/icons-material/MicNone';

function DemoStep3() {
    const [Status, setStatus] = React.useState('default');
  
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  return (
    <>
      <div className="form">
        <h3 className='hd_6'>Tell us about your business</h3>
        <div className="chat_form">
          <figure><img src="/static/images/question_icon.svg" alt='Icon' /></figure>
          <TextField hiddenLabel fullWidth multiline placeholder="Describe what you sell..."></TextField>
          <Button className='ai_icon btn btn_primary sm' > Enhance with AI </Button>
          <div className="chat_action">
            <IconButton className='btn_rounded primary br'><MicNoneIcon /></IconButton>
          </div>
        </div>
        <div className="control_group mt_20">
          <label htmlFor="">What is your average monthly sales volume?(AED)</label>
          <Select
            fullWidth
            value={Status}
            onChange={handleStatusChange} >
            <MenuItem disabled value="default">Select Range</MenuItem>
            <MenuItem value="All"> less than 5,000</MenuItem>
            <MenuItem value="Active">5,000–20,000</MenuItem>
            <MenuItem value="Suspended">50,000+</MenuItem>
          </Select>
        </div>
      </div>
    </>
  )
}

export default DemoStep3